var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.078,
    height: 199.009,
    viewBox: "0 0 194.078 199.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89368",
    "data-name": "Group 89368",
    transform: "translate(-6.115 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17595",
    "data-name": "Rectangle 17595",
    width: 46.051,
    height: 8.226,
    transform: "translate(80.129 169.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17596",
    "data-name": "Rectangle 17596",
    width: 46.051,
    height: 8.224,
    transform: "translate(80.129 182.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M61.4,99.5c6.083,0,17.964-3.312,20.808-8.223H40.59C43.434,96.192,55.314,99.5,61.4,99.5Z",
    transform: "translate(41.757 104.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M81.531,22.852A57.563,57.563,0,0,0,23.967,80.416c0,31.791,26.316,37.827,34.539,62.5h46.051c8.224-24.666,34.539-30.707,34.539-62.5A57.563,57.563,0,0,0,81.531,22.852Z",
    transform: "translate(21.623 21.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M104.853,46.653H85.116A1.644,1.644,0,0,0,83.471,48.3v6.581a1.646,1.646,0,0,0,1.645,1.643h19.737a1.644,1.644,0,0,0,1.645-1.643V48.3A1.644,1.644,0,0,0,104.853,46.653Z",
    transform: "translate(93.695 50.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M27.5,46.653H7.76A1.643,1.643,0,0,0,6.115,48.3v6.581A1.644,1.644,0,0,0,7.76,56.519H27.5a1.646,1.646,0,0,0,1.645-1.643V48.3A1.644,1.644,0,0,0,27.5,46.653Z",
    transform: "translate(0 50.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M77.532,38a1.648,1.648,0,0,0,2.328,0L93.815,24.044a1.643,1.643,0,0,0,0-2.326l-4.652-4.652a1.646,1.646,0,0,0-2.328,0L72.879,31.02a1.643,1.643,0,0,0,0,2.326Z",
    transform: "translate(80.281 14.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M34.464,71.765a1.643,1.643,0,0,0-2.326,0L18.18,85.723a1.643,1.643,0,0,0,0,2.326L22.833,92.7a1.647,1.647,0,0,0,2.326,0L39.114,78.746a1.643,1.643,0,0,0,0-2.326Z",
    transform: "translate(14.029 80.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M49.413,28.025h6.581a1.646,1.646,0,0,0,1.645-1.645V6.645A1.649,1.649,0,0,0,55.994,5H49.413a1.645,1.645,0,0,0-1.645,1.645V26.38A1.645,1.645,0,0,0,49.413,28.025Z",
    transform: "translate(50.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M32.137,38a1.643,1.643,0,0,0,2.326,0l4.652-4.652a1.643,1.643,0,0,0,0-2.326L25.161,17.064a1.647,1.647,0,0,0-2.326,0l-4.652,4.652a1.643,1.643,0,0,0,0,2.326Z",
    transform: "translate(14.032 14.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M79.859,71.765a1.646,1.646,0,0,0-2.328,0l-4.652,4.652a1.643,1.643,0,0,0,0,2.326L86.836,92.7a1.643,1.643,0,0,0,2.326,0l4.652-4.652a1.643,1.643,0,0,0,0-2.326Z",
    transform: "translate(80.28 80.282)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbe);
export default __webpack_public_path__ + "static/media/bulbe.7d485da86e6611635e1a538785063399.svg";
export { ForwardRef as ReactComponent };